/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetLoggedOutQueryPromptQueryVariables = Types.Exact<{
  backgroundJobId: Types.Scalars['String']['input'];
}>;

export type GetLoggedOutQueryPromptQuery = {
  __typename?: 'Query';
  fabiJobSearchLoggedOutQueryGenerationRetrieve?:
    | { __typename: 'FabiBadRequest'; message: string }
    | {
        __typename: 'FabiJobSearchLoggedOutQueryGenerationRetrieveResult';
        query: string;
        trackingToken: string;
      }
    | null;
};

export const GetLoggedOutQueryPromptDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetLoggedOutQueryPrompt' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'backgroundJobId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'fabiJobSearchLoggedOutQueryGenerationRetrieve',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'backgroundJobId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'backgroundJobId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value:
                        'FabiJobSearchLoggedOutQueryGenerationRetrieveResult',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'query' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'trackingToken' },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FabiBadRequest' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '__typename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetLoggedOutQueryPromptQuery,
  GetLoggedOutQueryPromptQueryVariables
>;
